require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/fn/object/values.js
// module id = 238
// module chunks = 169